import type { RouteRecordRaw } from 'vue-router';

export const taxRoutes: Array<RouteRecordRaw> = [
  {
    path: '/taxes',
    name: 'taxes',
    redirect: '/tax/list',
    component: () => import('pages/central/tax/McTax.vue'),
    meta: {
      title: 'Taxes',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/tax',
    name: 'tax',
    redirect: '/tax/list',
    component: () => import('pages/central/tax/McTax.vue'),
    meta: {
      title: 'Taxes',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'taxList',
        component: () => import('pages/central/tax/TaxList.vue'),
        meta: {
          title: 'Taxes List',
          requiresAuth: true,
        },
      },
      {
        path: 'salestax',
        name: 'salesTax',
        component: () => import('pages/central/tax/TaxList.vue'),
        meta: {
          title: 'Tax Details',
          requiresAuth: true,
        },
      },
      {
        path: 'incometax',
        name: 'incomeTax',
        component: () => import('pages/central/tax/TaxList.vue'),
        meta: {
          title: 'Income Taxes',
          requiresAuth: true,
        },
      },
      {
        path: 'importtax',
        name: 'importTax',
        component: () => import('pages/central/tax/TaxList.vue'),
        meta: {
          title: 'Import Taxes',
          requiresAuth: true,
        },
      },
      {
        path: 'businesstax',
        name: 'businessTax',
        component: () => import('pages/central/tax/TaxList.vue'),
        meta: {
          title: 'Business Taxes',
          requiresAuth: true,
        },
      },
      {
        path: 'propertytax',
        name: 'propertyTax',
        component: () => import('pages/central/tax/TaxList.vue'),
        meta: {
          title: 'Property Taxes',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'taxDetail',
        component: () => import('pages/central/tax/TaxDetail.vue'),
        meta: {
          title: 'Tax Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'taxNew',
        component: () => import('pages/central/tax/TaxNew.vue'),
        meta: {
          title: 'New Tax',
          requiresAuth: true,
        },
      },
    ],
  },
];
